import React from "react";
import { Controller } from "react-hook-form";
import SelectField from "../../ui/components/SelectField/SelectField";

export enum TransportEnum {
    AIRPLANE = 0,
    TRAIN = 1,
    BUS = 2,
    OTHER = 4,
}

export const transportChoices = [
    {id: TransportEnum.AIRPLANE, name: 'common.enum.transportType.plane'},
    {id: TransportEnum.TRAIN, name: 'common.enum.transportType.train'},
    // {id: TransportEnum.BUS, name: 'common.enum.transportType.bus'},
    {id: TransportEnum.OTHER, name: 'common.enum.transportType.other'},
];

/**
 * Gets translation keys for transport references
 * @param transportType - Transport type (AIRPLANE, TRAIN, BUS)
 * @returns Object with keys for reference and reference number
 */
export const getTransportReferenceKeys = (transportType?: number | string | null) => {
    switch (transportType) {
        case TransportEnum.AIRPLANE:
            return {
                referenceSource: "airline",
                numberSource: "flightNumber",
            };
        case TransportEnum.TRAIN:
            return {
                referenceSource: "trainCompany",
                numberSource: "trainNumber",
            };
        case TransportEnum.BUS:
            return {
                referenceSource: "busCompany",
                numberSource: "busNumber",
            };
        default:
            return {
                referenceSource: "arrivalTransportReference",
                numberSource: "arrivalTransportReferenceNumber",
            };
    }
};

/**
 * SelectField component for Arrival Transport
 */
export const ArrivalTransportSelect = ({ control, errors, t }: any) => {
    return (
        <div className="w-full">
            <Controller
                name="arrivalTransport"
                control={control}
                rules={{ required: t("common.feedback.field_required") }}
                render={({ field }) => (
                    <SelectField
                        {...field}
                        label={t("transfers.fields.arrivalTransport")}
                        error={(errors.arrivalTransport as any)?.message}
                    >
                        <option value=""></option>
                        {transportChoices.map((choice) => (
                            <option key={choice.id} value={choice.id}>
                                {t(choice.name)}
                            </option>
                        ))}
                    </SelectField>
                )}
            />
        </div>
    );
};

/**
 * SelectField component for Departure Transport
 */
export const DepartureTransportSelect = ({ control, errors, t }: any) => {
    return (
        <div className="w-full">
            <Controller
                name="departureTransport"
                control={control}
                rules={{ required: t("common.feedback.field_required") }}
                render={({ field }) => (
                    <SelectField
                        {...field}
                        label={t("transfers.fields.departureTransport")}
                        error={(errors.departureTransport as any)?.message}
                    >
                        <option value=""></option>
                        {transportChoices.map((choice) => (
                            <option key={choice.id} value={choice.id}>
                                {t(choice.name)}
                            </option>
                        ))}
                    </SelectField>
                )}
            />
        </div>
    );
};